(ns machtfit.feature
  (:require [re-frame.core :as rf]))

(rf/reg-cofx ::django-flags
  (fn [cofx]
    (assoc cofx :django-flags
           (when (exists? js/feature_flags)
             (js->clj js/feature_flags :keywordize-keys true)))))

(rf/reg-event-fx ::load-django-flags
  [(rf/inject-cofx ::django-flags)]
  (fn [{:keys [db django-flags]} _]
    {:db (assoc db :django-feature-flags django-flags)}))

(rf/reg-sub ::feature-flag-enabled?
  (fn [db [_ feature]]
    (get-in db [:django-feature-flags feature])))
